var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMolot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33956 17.1557H10.6729C11.1312 17.1557 11.5062 17.5307 11.5062 17.9891C11.5062 18.4474 11.1312 18.8224 10.6729 18.8224H2.33956C1.88123 18.8224 1.50623 18.4474 1.50623 17.9891C1.50623 17.5307 1.88123 17.1557 2.33956 17.1557ZM5.03956 6.38074L7.39789 4.02241L18.0062 14.6307C18.6562 15.2807 18.6562 16.3391 18.0062 16.9891C17.3562 17.6391 16.2979 17.6391 15.6479 16.9891L5.03956 6.38074ZM12.1146 1.66408L14.4729 4.02241C15.1229 4.67241 15.1229 5.73074 14.4729 6.38074L13.2896 7.56408L8.58123 2.84741L9.75623 1.67241C10.4062 1.01408 11.4646 1.01408 12.1146 1.66408ZM3.86456 7.55574L8.58123 12.2724L7.40623 13.4474C6.75623 14.0974 5.69789 14.0974 5.04789 13.4474L2.68956 11.0891C2.03956 10.4391 2.03956 9.38074 2.68956 8.73074L3.86456 7.55574Z",
    fill: "#E31A87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMolot);
export default __webpack_public_path__ + "static/media/molot.2006d3be1a55292933b93deab3425216.svg";
export { ForwardRef as ReactComponent };